// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5c9cb0b8","732":"3f3de292","977":"8a7f6b3c"}[chunkId] + ".chunk.js";
};